import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {UserDetailComponent} from "./user-detail.component";
import {UserDeleteDialogModule} from "./../partials/user-delete-dialog/user-delete-dialog.module";
import {MatButtonModule} from "@angular/material/button";
import {CardOverlayModule} from "@pages/user/partials/card-overlay/card-overlay.module";
import {MatDividerModule} from "@angular/material/divider";
import { UserEmailChangeDialogModule } from '../partials/user-emailchange-dialog/user-change-dialog.module';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
// import {ParticipantDetailCardModule} from "@pages/user/partials/participant-detail-card/participant-detail-card.module";


@NgModule({
  declarations: [UserDetailComponent],
  exports: [UserDetailComponent],
  imports: [
    CommonModule,
    MatButtonModule,
    UserDeleteDialogModule,
    UserEmailChangeDialogModule,
    MatDividerModule,
    CardOverlayModule
    // ParticipantDetailCardModule
  ]
})
export class UserDetailModule { }
